import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { SigninComponent } from './signin/signin.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { VerificationCodeComponent } from './verification-code/verification-code.component';
import { ResendCodeComponent } from './resend-code/resend-code.component';
import { AuthGuard } from '../interceptors/auth.guard';
import { NoauthGuard } from '../interceptors/noauth.guard';
import { DeleteComponent } from './delete/delete.component';
import { ForgotPasswordSubmitComponent } from './forgot-password-submit/forgot-password-submit.component';
import { AccountViewVerificationCodeComponent } from "./account-view-verification-code/account-view-verification-code.component";

const routes: Routes = [
    {
        path: '',
        children: [
            { path: 'delete', component: DeleteComponent, canActivate: [AuthGuard], data: { title: 'Delete Account' } },
            { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [NoauthGuard], data: { title: 'Forgot Password' } },
            { path: 'forgot-password-submit', component: ForgotPasswordSubmitComponent, canActivate: [NoauthGuard], data: { title: 'Reset Password' } },
            { path: 'signin', component: SigninComponent, canActivate: [NoauthGuard], data: { title: 'Sign In' } },
            { path: 'register', component: RegisterComponent, canActivate: [NoauthGuard], data: { title: 'Sign Up' } },
            { path: 'verification-code', component: VerificationCodeComponent, canActivate: [AuthGuard], data: { title: 'Verification Code' } },
            { path: 'account-view-verification-code', component: AccountViewVerificationCodeComponent, canActivate: [AuthGuard], data: { title: 'Account View Verification Code' } },
            { path: 'resend-code', component: ResendCodeComponent, canActivate: [AuthGuard], data: { title: 'Resend Verification Code' } },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AccountRoutingModule {}
